import React, {useEffect, useRef, useState} from 'react';
import {getUserProfile} from '../utils/dbUtils';
import {db} from '../config/firebase';
import {doc, updateDoc} from 'firebase/firestore';
import {getStorage, ref, uploadBytes, getDownloadURL} from 'firebase/storage';
import {compressImage} from '../utils/compressImage';
import { useAuth } from '../Auth/AuthContext';
import { useNavigate } from 'react-router-dom'; // <- AÑADIR
import { useToast } from '../context/ToastContext'; // <- AÑADIR
import profileIcon from '../Icons/profile-menu.png';
import './EditProfile.css';

const foodCategories = [
  {
    label: "Mediterránea",
    value: "Mediterránea",
    subtypes: [
      {label: "Italiana", value: "Italiana"},
      {label: "Española", value: "Española"},
      {label: "Griega", value: "Griega"},
      {label: "Francesa", value: "Francesa"},
      {label: "Libanesa/Medio Oriente", value: "Libanesa/Medio Oriente"},
      {label: "Turca", value: "Turca"},
      {label: "Israelí", value: "Israelí"},
      {label: "Marroquí", value: "Marroquí"},
    ],
 },
  {
    label: "Asiática",
    value: "Asiática",
    subtypes: [
      {label: "China", value: "China"},
      {label: "Japonesa", value: "Japonesa"},
      {label: "India", value: "India"},
      {label: "Tailandesa", value: "Tailandesa"},
      {label: "Vietnamita", value: "Vietnamita"},
      {label: "Coreana", value: "Coreana"},
      {label: "Malaya/Singapurense", value: "Malaya/Singapurense"},
      {label: "Filipina", value: "Filipina"},
      {label: "Indonesia", value: "Indonesia"},
    ],
 },
  {
    label: "Americana",
    value: "Americana",
    subtypes: [
      {label: "Mexicana", value: "Mexicana"},
      {label: "Peruana", value: "Peruana"},
      {label: "Brasileña", value: "Brasileña"},
      {label: "Argentina", value: "Argentina"},
      {label: "Estadounidense", value: "Estadounidense"},
      {label: "Caribeña", value: "Caribeña"},
    ],
 },
  {
    label: "Africana",
    value: "Africana",
    subtypes: [
      {label: "Etíope/Eritrea", value: "Etíope/Eritrea"},
      {label: "Sudafricana", value: "Sudafricana"},
    ],
 },
  {label: "Fusión", value: "Fusión"},
  {label: "De Autor / Vanguardia", value: "De Autor / Vanguardia"},
  {label: "Tradicional / Regional", value: "Tradicional / Regional"},
  {label: "Gourmet / Alta Cocina", value: "Gourmet / Alta Cocina"},
  {label: "Saludable / Fitness", value: "Saludable / Fitness"},
  {label: "Vegetariana", value: "Vegetariana"},
  {label: "Vegana", value: "Vegana"},
  {label: "Sin Gluten", value: "Sin Gluten"},
  {label: "Sin Lactosa", value: "Sin Lactosa"},
  {label: "Repostería / Panadería", value: "Repostería / Panadería"},
];

const EditProfile = () => {
  const { userId } = useAuth();
  const navigate = useNavigate(); // <- AÑADIR
  const { showToast } = useToast(); // <- AÑADIR
  const [userData, setUserData] = useState({
    name: '',
    userName: '',
    genero: '',
    profileImage: '',
    tiposComidaPreferidos: []
 });
  const [saving, setSaving] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const fetchUser = async () => {
      const data = await getUserProfile(userId);
      if (data) {
        setUserData({
          userName: data.userName || '',
          genero: data.genero || '',
          profileImage: data.profileImage || '',
          tiposComidaPreferidos: data.tiposComidaPreferidos || []
       });
     }
   };
    fetchUser();
 }, [userId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
     }
   };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
 }, []);

  const handleChange = (e) => {
    setUserData({...userData, [e.target.name]: e.target.value});
 };

  const handleImageClick = () => {
    document.getElementById('profile-image-input').click();
 };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setSaving(true);
      try {
        const compressed = await compressImage(file, 400, 0.8); // foto de perfil: 400px
        const storage = getStorage();
        const imageId = Date.now();
        const storageRef = ref(storage, `profileImages/${userId}/${imageId}`);
        await uploadBytes(storageRef, compressed);
        const imageUrl = await getDownloadURL(storageRef);
        setUserData({...userData, profileImage: imageUrl});
      } catch (err) {
        console.error('[EditProfile] Error subiendo imagen:', err);
      } finally {
        setSaving(false);
      }
   }
 };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    const profileImageUrl = userData.profileImage; // <- ya tiene la URL (subida en handleImageChange)
    const userDocRef = doc(db, 'users', userId);
    await updateDoc(userDocRef, {
      userName: userData.userName,
      genero: userData.genero,
      profileImage: profileImageUrl,
      tiposComidaPreferidos: userData.tiposComidaPreferidos
    });
    setSaving(false);
    showToast('Perfil actualizado correctamente', 'success');
    navigate('/profile');
 };

  const handleTipoComidaChange = (value, isCategory = false, subtypes = []) => {
    setUserData(prev => {
      let nuevosTipos = [...prev.tiposComidaPreferidos];
      if (isCategory) {
        const allSelected = [value, ...subtypes.map(s => s.value)].every(v => nuevosTipos.includes(v));
        if (allSelected) {
          // Desmarcar categoría y subtipos
          nuevosTipos = nuevosTipos.filter(v => v !== value && !subtypes.map(s => s.value).includes(v));
       } else {
          // Marcar categoría y todos los subtipos
          nuevosTipos = Array.from(new Set([...nuevosTipos, value, ...subtypes.map(s => s.value)]));
       }
     } else {
        if (nuevosTipos.includes(value)) {
          nuevosTipos = nuevosTipos.filter(v => v !== value);
       } else {
          nuevosTipos.push(value);
       }
     }
      return {...prev, tiposComidaPreferidos: nuevosTipos};
   });
 };

  return (
    <div className="user-profile">
      <h2>Editar Perfil</h2>
      <form onSubmit={handleSave}>
        <div className="edit-profile-form">
          <img
            src={userData.profileImage || profileIcon}
            alt="Imagen de perfil"
            className="profile-image"
            onClick={handleImageClick}
            title="Haz click para cambiar la imagen"
          />
          <input
            id="profile-image-input"
            type="file"
            accept="image/*"
            className="profile-image-input"
            onChange={handleImageChange}
          />
          <input
            type="text"
            name="userName"
            placeholder="Nombre de usuario"
            value={userData.userName}
            onChange={handleChange}
            autoComplete="off"
            className="edit-profile-input"
          />
          <select
            name="genero"
            value={userData.genero}
            onChange={handleChange}
            className="edit-profile-select"
          >
            <option value="">Selecciona tu género</option>
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
            <option value="Prefiero no contestar">Prefiero no contestar</option>
          </select>
          <div className="dropdown-multiselect-wrapper">
            <label className="dropdown-multiselect-label">Tipos de comida preferidos:</label>
            <div
              className="dropdown-multiselect"
              onClick={() => setShowDropdown((v) => !v)}
            >
              {userData.tiposComidaPreferidos.length === 0
                ? <span className="dropdown-multiselect-placeholder">Selecciona tipos de comida</span>
                : userData.tiposComidaPreferidos.join(', ')
             }
            </div>
            {showDropdown && (
              <div
                ref={dropdownRef}
                className="dropdown-multiselect-list"
              >
                {foodCategories.map(cat => (
                  <div key={cat.value} className="dropdown-multiselect-category">
                    <label className={`dropdown-multiselect-category-label${cat.subtypes ? ' bold' : ''}`}>
                      <input
                        type="checkbox"
                        checked={userData.tiposComidaPreferidos.includes(cat.value)}
                        onChange={e => {
                          e.stopPropagation();
                          handleTipoComidaChange(
                            cat.value,
                            !!cat.subtypes,
                            cat.subtypes || []
                          );
                       }}
                      />
                      {cat.label}
                    </label>
                    {cat.subtypes && (
                      <div className="dropdown-multiselect-subtypes">
                        {cat.subtypes.map(sub => (
                          <label key={sub.value} className="dropdown-multiselect-subtype-label">
                            <input
                              type="checkbox"
                              checked={userData.tiposComidaPreferidos.includes(sub.value)}
                              onChange={e => {
                                e.stopPropagation();
                                handleTipoComidaChange(sub.value);
                             }}
                            />
                            {sub.label}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          <button type="submit" className="edit-profile-btn" disabled={saving}>
            {saving ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfile;